import { render, staticRenderFns } from "./index.vue?vue&type=template&id=69519ad6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=69519ad6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69519ad6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69519ad6')) {
      api.createRecord('69519ad6', component.options)
    } else {
      api.reload('69519ad6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=69519ad6&scoped=true", function () {
      api.rerender('69519ad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/LayoutFooter/index.vue"
export default component.exports